<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class=" basic ? 'ic-svg' : '' "><use :xlink:href="`#${name}`"></use></svg>
</template>

<script>
export default {
  name: 'SvgUse',
  props: {
    name: {
      required: true,
      type: String
    },
    basic: {
      required: false,
      type: Boolean
    }
  }
}
</script>
